<ion-header id="tab-header-icons">
  <ion-toolbar class="toolbar">
    <div id="container">
      <a [routerLink]="['/']">
        <ion-img class="header-logo" src="../../../../assets/images/logos/logo-mini.svg"></ion-img>
      </a>
      <div id="header-container" *ngIf="this.applicationTypeService.applicationType$">
        <ion-text
          class="school-name"
          *ngIf="this.applicationTypeService.applicationType$.getValue() !== 'Officials'"
          >{{ this.applicationTypeService.organizationName$ | async }}</ion-text
        >
        <div>
          <ion-text class="type-name type-text" slot="end">
            {{ this.applicationTypeService.applicationType$ | async }}
          </ion-text>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
